import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Badge,
  Button,
  Col,
  Dropdown,
  List,
  Row,
  Skeleton,
} from "antd";
import moment from "moment";
import { BellOutlined } from "@ant-design/icons";
import { useSocket } from "../../utils/socketio/SocketWrapper";
import {
  api_countNotification,
  api_getNotification,
  api_readAllNotification,
  api_readNotification,
} from "../../services/notification";
import { useAuth } from "../../utils/Auth/AuthWrapper";
import "./styles/index.less";

type Props = {};

const Notification = (props: Props) => {
  const [notifications, setNotifications] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(10);
  const [totalUnread, setTotalUnread] = useState(0);

  const { socket, isConnected } = useSocket() as any;
  const auth = useAuth();
  const loadMore = (
    // linitLoading && !loading? (
    <div
      style={{
        textAlign: "center",
        marginTop: 12,
        height: 32,
        lineHeight: "32px",
      }}
    >
      <Button
        type="link"
        onClick={() => {
          setPage(page + 1);
          getData(page + 1);
        }}
      >
        loading more
      </Button>
    </div>
  );

  const getCountUnread = useCallback(async () => {
    try {
      const data = {
        user_id: auth.user.user_id,
      };
      const res = await api_countNotification(data);
      if (res.success === true) {
        setTotalUnread(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  }, [auth.user.user_id]);

  const getData = useCallback(
    async (pageChange?: any, replace?: boolean) => {
      try {
        const targetPage = pageChange ? pageChange : 1;
        const data = {
          user_id: auth.user.user_id,
          limit: 10,
          page: targetPage,
          size: pageSize,
        };
        const res = await api_getNotification(data);
        const new_format = res.data.map((item: any, ind: number) => {
          return {
            id: ind + 1,
            noti_id: item.notice_id,
            content: item.content,
            timestamp: moment(item.date).format("YYYY-MM-DD HH:mm:ss"),
            status: item.status,
          };
        });
        setTotal(res.meta.total);
        setPage(res.meta.page);
        setNotifications((prev: any[]) =>
          replace || targetPage === 1 ? new_format : [...prev, ...new_format],
        );
      } catch (e) {
        console.error(e);
      }
    },
    [auth.user.user_id, pageSize],
  );

  useEffect(() => {
    const currentSocket = socket?.current;
    if (!currentSocket || !isConnected) {
      return;
    }

    const handleNotification = (data: any) => {
      if (auth.user.user_id == data.user_id) {
        getData(1, true);
        getCountUnread();
      }
    };

    currentSocket.on("notification", handleNotification);

    return () => {
      currentSocket.off("notification", handleNotification);
    };
  }, [auth.user.user_id, getCountUnread, getData, isConnected, socket]);

  useEffect(() => {
    getData(1, true);
    getCountUnread();
  }, [getCountUnread, getData]);

  const handleReadAll = useCallback(async () => {
    try {
      const res = await api_readAllNotification({
        user_id: auth.user.user_id,
        status: 2,
      });
      if (res.status == true) {
        await Promise.all([getData(1, true), getCountUnread()]);
      }
    } catch (e) {
      console.error(e);
    }
  }, [auth.user.user_id, getCountUnread, getData]);

  const reloadNoti = useMemo(() => {
    const result = notifications;
    return result;
  }, [notifications]);

  const reloadCount = useMemo(() => {
    const result = totalUnread;
    return result;
  }, [totalUnread]);

  return (
    <>
      <Row style={{ height: "100%" }} align={"middle"} justify={"center"}>
        <Dropdown
          placement="bottom"
          trigger={["click"]}
          onOpenChange={(open) => {
            if (open) {
              handleReadAll();
            }
          }}
          dropdownRender={() => {
            return (
              <div
                style={{
                  marginTop: "Irem",
                  background: "white",
                  padding: "10px",
                  borderRadius: "10px",
                  width: "400px",
                  boxShadow: "Opx Opx 3px #DCDCDC",
                }}
              >
                <Row justify={"center"} align={"middle"}>
                  <Col></Col>
                  <Col style={{ fontSize: "14pt", fontWeight: "bold" }}>
                    การแจ้งเตือน
                  </Col>
                  {/* <Col>
                    <Dropdown menu={{ items }}>
                      <EllipsisOutlined
                        style={{
                          color: "black",
                          fontSize: "16pt",
                          cursor: "pointer",
                        }}
                        rotate={90}
                      />
                    </Dropdown>
                  </Col> */}
                </Row>
                <List
                  className="demo-loadmore-list"
                  loading={false}
                  loadMore={
                    notifications && notifications.length < total ? (
                      loadMore
                    ) : (
                      <></>
                    )
                  }
                  itemLayout="horizontal"
                  style={{
                    overflowY: "auto",
                    height: "300px",
                    paddingRight: "10px",
                    paddingLeft: "10px",
                  }}
                  dataSource={reloadNoti}
                  renderItem={(item: any) => (
                    <List.Item
                      key={item.noti_id}
                      id={item.noti_id}
                      style={
                        item.status == 1
                          ? { background: "#8cc7fa7e" }
                          : { background: "white" }
                      }
                      className="list-noti"
                      onClick={async () => {
                        const res = await api_readNotification({
                          notification_id: item.noti_id,
                          status: 2,
                        });
                        if (res.status === true) {
                          const readNoti = notifications.map((i: any) => {
                            if (i.noti_id == item.noti_id) {
                              return { ...i, status: 2 };
                            }
                            return i;
                          });
                          getCountUnread();
                          setNotifications(readNoti);
                        }
                      }}
                    >
                      <Skeleton avatar title={false} loading={false} active>
                        <List.Item.Meta
                          avatar={<Avatar icon={<BellOutlined />} />}
                          // title={<div>{item.create_by}</div>}
                          description={
                            <>
                              <span
                                style={{ color: "#000000", fontWeight: "bold" }}
                              >
                                {item.content}
                              </span>
                              <br />
                              <span style={{ color: "#888" }}>
                                {moment(item.timestamp).fromNow()}
                              </span>
                            </>
                          }
                        />
                      </Skeleton>
                    </List.Item>
                  )}
                />
              </div>
            );
          }}
        >
          <Badge count={reloadCount} style={{ cursor: "pointer" }}>
            <BellOutlined
              style={{ fontSize: "20px", color: "black", cursor: "pointer" }}
            />
          </Badge>
        </Dropdown>
      </Row>
    </>
  );
};

export default Notification;
